import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { cx } from '../internal/variants.js';
const MARK = { add: '+', del: '-', ctx: ' ' };
export function DiffView({ lines }) {
    return (_jsx("div", { role: "group", "aria-label": "diff", children: lines.map((line, i) => (_jsxs("span", { className: cx('diff-line', line.type === 'add' && 'diff-add', line.type === 'del' && 'diff-del'), children: [_jsxs("span", { className: "diff-gutter", "aria-hidden": "true", children: [MARK[line.type], ' '] }), line.text] }, i))) }));
}
//# sourceMappingURL=DiffView.js.map